import {
  withJsonFormsControlProps,
  withJsonFormsLayoutProps,
} from '@jsonforms/react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { ModalDisplay } from '../container/Modal'
import {
  CardDisplay,
  SubCardDisplay,
} from 'designer/component/control/container/Card'
import {
  CollapseDisplay,
  SubCollapseDisplay,
} from 'designer/component/control/container/Collapse'
import {
  PanelDisplay,
  SubPanelDisplay,
} from 'designer/component/control/container/Panel'
import {
  SubTabDisplay,
  TabDisplay,
} from 'designer/component/control/container/Tab'
import {
  TabPanelDisplay,
  SubTabPanelDisplay,
} from 'designer/component/control/container/TabPanel'
import {
  DynamicDisplay,
  SubDynamicDisplay,
} from 'designer/component/control/container/Dynamic'
import {
  DynamicDisplayPanel,
  SubDynamicDisplayPanel,
} from 'designer/component/control/container/DynamicPanel'
import {
  EditDisplayPanel,
  SubEditDisplayPanel,
} from 'designer/component/control/container/EditPanel'
import {
  SubPanelGroupDisplay,
  PanelGroupDisplay,
} from 'designer/component/control/container/PanelGroup'

const cardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => !schema.subGroup)
)
const subCardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => schema.subGroup)
)
const collapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => !schema.subGroup)
)
const subCollapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => schema.subGroup)
)
const panelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => !schema.subGroup)
)
const subPanelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => schema.subGroup)
)
const tabTester = rankWith(
  3,
  and(scopeEndsWith('tab'), (schema) => !schema.subGroup)
)
const subTabTester = rankWith(
  3,
  and(scopeEndsWith('tab'), (schema) => schema.subGroup)
)
const tabPanelTester = rankWith(3, scopeEndsWith('tabPanel'))
const dynamicTester = rankWith(
  3,
  and(scopeEndsWith('dynamic'), (schema) => !schema.subGroup)
)
const subDynamicTester = rankWith(
  3,
  and(scopeEndsWith('dynamic'), (schema) => schema.subGroup)
)
const dynamicPanelTester = rankWith(3, scopeEndsWith('dynamicPanel'))
const editPanelTester = rankWith(3, scopeEndsWith('editPanel'))
const modalTester = rankWith(3, scopeEndsWith('modal'))
const panelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => !schema.subGroup)
)
const subPanelGroupTester = rankWith(
  3,
  and(scopeEndsWith('panelGroup'), (schema) => schema.subGroup)
)

const Card = (props) => <CardDisplay {...props} />
const SubCard = (props) => <SubCardDisplay {...props} />
const Collapse = (props) => <CollapseDisplay {...props} />
const SubCollapse = (props) => <SubCollapseDisplay {...props} />
const Panel = (props) => <PanelDisplay {...props} />
const SubPanel = (props) => <SubPanelDisplay {...props} />
const Tab = (props) => <TabDisplay {...props} />
const SubTab = (props) => <SubTabDisplay {...props} />
const TabPanel = (props) => <TabPanelDisplay {...props} />
const SubTabPanel = (props) => <SubTabPanelDisplay {...props} />
const Dynamic = (props) => <DynamicDisplay {...props} />
const SubDynamic = (props) => <SubDynamicDisplay {...props} />
const DynamicPanel = (props) => <DynamicDisplayPanel {...props} />
const SubDynamicPanel = (props) => <SubDynamicDisplayPanel {...props} />
const EditPanel = (props) => <EditDisplayPanel {...props} />
const SubEditPanel = (props) => <SubEditDisplayPanel {...props} />
const Modal = (props) => <ModalDisplay {...props} />
const PanelGroup = (props) => <PanelGroupDisplay {...props} />
const SubPanelGroup = (props) => <SubPanelGroupDisplay {...props} />

export const containerDisplayRenderer = {
  modal: {
    tester: modalTester,
    renderer: withJsonFormsControlProps(Modal),
  },
  main: {
    card: {
      tester: cardTester,
      renderer: withJsonFormsControlProps(Card),
    },
    collapse: {
      tester: collapseTester,
      renderer: withJsonFormsControlProps(Collapse),
    },
    panel: {
      tester: panelTester,
      renderer: withJsonFormsControlProps(Panel),
    },
    tab: {
      tester: tabTester,
      renderer: withJsonFormsControlProps(Tab),
    },
    tabPanel: {
      tester: tabPanelTester,
      renderer: withJsonFormsLayoutProps(TabPanel),
    },
    dynamic: {
      tester: dynamicTester,
      renderer: withJsonFormsControlProps(Dynamic),
    },
    dynamicPanel: {
      tester: dynamicPanelTester,
      renderer: withJsonFormsControlProps(DynamicPanel),
    },
    editPanel: {
      tester: editPanelTester,
      renderer: withJsonFormsControlProps(EditPanel),
    },
    panelGroup: {
      tester: panelGroupTester,
      renderer: withJsonFormsControlProps(PanelGroup),
    },
  },
  sub: {
    card: {
      tester: subCardTester,
      renderer: withJsonFormsControlProps(SubCard),
    },
    collapse: {
      tester: subCollapseTester,
      renderer: withJsonFormsControlProps(SubCollapse),
    },
    panel: {
      tester: subPanelTester,
      renderer: withJsonFormsControlProps(SubPanel),
    },
    tab: {
      tester: subTabTester,
      renderer: withJsonFormsControlProps(SubTab),
    },
    tabPanel: {
      tester: tabPanelTester,
      renderer: withJsonFormsLayoutProps(SubTabPanel),
    },
    dynamic: {
      tester: subDynamicTester,
      renderer: withJsonFormsControlProps(SubDynamic),
    },
    dynamicPanel: {
      tester: dynamicPanelTester,
      renderer: withJsonFormsControlProps(SubDynamicPanel),
    },
    editPanel: {
      tester: editPanelTester,
      renderer: withJsonFormsControlProps(SubEditPanel),
    },
    panelGroup: {
      tester: subPanelGroupTester,
      renderer: withJsonFormsControlProps(SubPanelGroup),
    },
  },
}
